module.exports = __webpack_public_path__ + "static/img/8.c8ff94ea.png";